// Modal states for the single auth modal
export const AUTH_MODAL_STATES = {
    EMAIL_INPUT: 'email_input', // Default state - user enters email
    SIGN_IN: 'sign_in', // Existing user - show password field
    SIGN_UP: 'sign_up', // New user - show name and password fields
};
